import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper";

class Carousel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            manipulatedChildren: null,
            translate: '',
            scrollLocked: false,
            transitionDuration: '1s'
        }
        this.outerContainer = React.createRef();
        this.calculatedChildWidth = 1;
        this.itemsInView = 0;

        this.initiated = false;
        this.isMobile = window.outerWidth < 576;
        this.childWidthMultiplier = this.isMobile ? .5 : 1;
        this.paddedChildren = 2 / this.childWidthMultiplier;
        this.translateMultiplier = this.isMobile ? 1.5 : 1;
    }

    componentDidUpdate() {
        if (!this.initiated && this.props.children.length){
            this.initiated = true;
            this.calculatedChildWidth = this.isMobile ? window.outerWidth / 2 : this.props.itemWidth;
            this.setItemsInView();
            this.setCalculatedChildWidth();
            this.manipulateChildren(true);
        }
    }

    setCalculatedChildWidth() {
        const outerContainer = this.outerContainer.current;
        if(!outerContainer){
            return;
        }
        this.calculatedChildWidth = outerContainer.offsetWidth / (this.itemsInView);
    }

    setItemsInView() {
        const outerContainer = this.outerContainer.current;

        if(!outerContainer){
            return;
        }
        this.itemsInView = parseInt(outerContainer.offsetWidth / this.calculatedChildWidth);
    }

    cloneArray (array) {
        return array.map((obj) => {
            return Object.assign({}, obj);
        });
    }

    manipulateChildren(setState, props) {
        const children = props?.children || this.props.children;
        if(children.length == 0 ) {
            return children;
        }

        const clone = this.cloneArray(children);
        const returner = clone.map((item, index) => {
            return (<SwiperSlide key={index}><div className="carousel__item">{item}</div></SwiperSlide>)
        });

        if(setState){
            this.setState({
                manipulatedChildren: returner,
                translate: 0,
                scrollLocked: false,
                transitionDuration: '0s'
            });
        }

    }

    render() {
        this.setItemsInView();
        this.setCalculatedChildWidth();
        return (
            <React.Fragment>
                <div className="slider_wrapper carousel__outer-container" ref={this.outerContainer}>
                    <div id="js-prev" className="carousel__arrow--container carousel__arrow--container-left">
                        <i className="carousel__arrow carousel__arrow--left"></i>
                    </div>
                    <div className="carousel__inner-container cts-impression-group">
                    <Swiper
                        modules={[Pagination,Autoplay,Navigation]}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: true,
                        }}
                        loop={true}
                        spaceBetween={50}
                        breakpoints={{
                            '0': {slidesPerView: 2},
                            '600': {slidesPerView: 3},
                            '1024': {slidesPerView: 5},
                        }}
                        pagination={{
                            clickable: true,
                            el: '.swiper-pagination',
                        }}
                        navigation={{
                            nextEl: '#js-next',
                            prevEl: '#js-prev',
                        }}
                    >
                        {this.state.manipulatedChildren}
                    </Swiper>
                    </div>
                    <div id="js-next" className="carousel__arrow--container carousel__arrow--container-right">
                        <i className="carousel__arrow carousel__arrow--right"></i>
                    </div>
                    <div className="carousel__dots">
                        <div className='swiper-pagination'></div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default Carousel;
